export default {
  title: 'General info',
  subtitle: 'Please enter the name and email of a new user',
  created: 'Created: ',
  activity: 'Last login: ',
  noActivity: 'Last login: -',
  userName: 'Username: ',
  phoneNumber: 'Phone number: ',
  approvalDateTime: 'Solera approval date: ',
  noApprovalDateTime: 'Solera approval date: -',
  nextBillingDate: 'Next billing date: ',
  noNextBillingDate: 'Next billing date: -',
  accountNumber: 'Account number ',
  placeholder: {
    firstName: 'First name*',
    middleName: 'Middle name',
    lastName: 'Last name*',
    email: 'Email*',
    type: 'Profile type*',
    custodianType: 'Custodian*',
    businessName: 'Business name',
    annualFee: 'Annual fee*',
    etzFee: 'ETZ fee (transaction share)*',
    nextBillingDate: 'Next billing date',
    custodyFeePercentage: '% annual custody/maintenance fee',
    custodyFeeAbsolute: '$ annual custody/maintenance fee',
  },
  custodyFeeTitle: 'Custody/maintenance fee',
};
